import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const EdrPage = lazy(() => import('../pages/edr/page'));
const IntuneMainPage = lazy(() => import('../pages/intune/page'));
const SentinelMainPage = lazy(() => import('../pages/sentinel/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));

// EDR Articles
const DefenderForEndpointPage = lazy(() => import('../pages/edr/articles/defender-for-endpoint/page'));
const AsrKurallariPage = lazy(() => import('../pages/edr/articles/asr-kurallari/page'));
const AirOtomatikYanitPage = lazy(() => import('../pages/edr/articles/air-otomatik-yanit/page'));
const TvmGuvenlikAcigiPage = lazy(() => import('../pages/edr/articles/tvm-guvenlik-acigi/page'));

// Intune Articles
const ModernCihazYonetimiPage = lazy(() => import('../pages/intune/articles/modern-cihaz-yonetimi/page'));
const UygulamaKorumaPolitikalariPage = lazy(() => import('../pages/intune/articles/uygulama-koruma-politikalari/page'));
const WindowsAutopilotPage = lazy(() => import('../pages/intune/articles/windows-autopilot/page'));

// Sentinel Articles
const SentinelKurulumRehberiPage = lazy(() => import('../pages/sentinel/articles/sentinel-kurulum-rehberi/page'));
const SentinelMaliyetOptimizasyonuPage = lazy(() => import('../pages/sentinel/articles/sentinel-maliyet-optimizasyonu/page'));
const SoarLogicAppsPage = lazy(() => import('../pages/sentinel/articles/soar-logic-apps/page'));
const OpenClawAIAjanlarPage = lazy(() => import('../pages/sentinel/articles/openclaw-ai-ajanlar/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/edr',
    element: <EdrPage />,
  },
  {
    path: '/edr/defender-for-endpoint',
    element: <DefenderForEndpointPage />,
  },
  {
    path: '/edr/asr-kurallari',
    element: <AsrKurallariPage />,
  },
  {
    path: '/edr/air-otomatik-yanit',
    element: <AirOtomatikYanitPage />,
  },
  {
    path: '/edr/tvm-guvenlik-acigi',
    element: <TvmGuvenlikAcigiPage />,
  },
  {
    path: '/intune',
    element: <IntuneMainPage />,
  },
  {
    path: '/intune/modern-cihaz-yonetimi',
    element: <ModernCihazYonetimiPage />,
  },
  {
    path: '/intune/uygulama-koruma-politikalari',
    element: <UygulamaKorumaPolitikalariPage />,
  },
  {
    path: '/intune/windows-autopilot',
    element: <WindowsAutopilotPage />,
  },
  {
    path: '/sentinel',
    element: <SentinelMainPage />,
  },
  {
    path: '/sentinel/sentinel-kurulum-rehberi',
    element: <SentinelKurulumRehberiPage />,
  },
  {
    path: '/sentinel/sentinel-maliyet-optimizasyonu',
    element: <SentinelMaliyetOptimizasyonuPage />,
  },
  {
    path: '/sentinel/soar-logic-apps',
    element: <SoarLogicAppsPage />,
  },
  {
    path: '/sentinel/openclaw-ai-ajanlar',
    element: <OpenClawAIAjanlarPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;